// src/components/CustomToolbar.js
import React from "react";

const CustomToolbar = ({ label, onNavigate }) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex gap-2">
        <button
          onClick={() => onNavigate('TODAY')}
          className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Oggi
        </button>
        <button
          onClick={() => onNavigate('PREV')}
          className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
        >
          ←
        </button>
        <button
          onClick={() => onNavigate('NEXT')}
          className="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400"
        >
          →
        </button>
      </div>
      <div className="text-xl font-semibold">{label}</div>
    </div>
  );
};

export default CustomToolbar;
